import ReduxHelper from 'lib/ReduxHelper';
import { GT_ESTIMATE_ACTION_TYPES as AT } from './GTEstimate.actions';
import { APP_ACTION_TYPES } from '../app/App.actions';

export const defaultState = {
  dashboardDataError: null,
  fetchingDashboardData: false,
  dashboardData: null,

  rerunError: null,
  rerunningData: false,
  rerunData: null,

  updateError: null,
  updatingData: false,
  updateData: null,

  resetProcessingError: null,
  resetingProcessing: false,
  resetProcessing: null,

  deleteError: null,
  deletingData: false,
  deleteData: null,
};

const gtEstimateReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.GT_ESTIMATE_FETCH_DATA: {
      return Object.assign({}, state, { fetchingDashboardData: true });
    }
    case AT.GT_ESTIMATE_FETCH_DATA_SUCCESS: {
      return Object.assign({}, state, {
        fetchingDashboardData: false,
        dashboardData: action.payload,
        dashboardDataError: null,
      });
    }
    case AT.GT_ESTIMATE_FETCH_DATA_FAIL:
      return Object.assign({}, state, {
        fetchingDashboardData: false,
        dashboardData: null,
        dashboardDataError: ReduxHelper.extractError(action),
      });
    case AT.GT_ESTIMATE_FETCH_CLEAR_DATA:
      return Object.assign({}, state, {
        fetchingDashboardData: false,
        dashboardData: null,
        dashboardDataError: null,
      });
    case AT.GT_ESTIMATE_RERUN_DATA: {
      return Object.assign({}, state, { rerunningData: true });
    }
    case AT.GT_ESTIMATE_RERUN_DATA_SUCCESS: {
      return Object.assign({}, state, {
        rerunningData: false,
        rerunData: action.payload,
        rerunError: null,
      });
    }
    case AT.GT_ESTIMATE_RERUN_DATA_FAIL:
      return Object.assign({}, state, {
        rerunningData: false,
        rerunData: null,
        rerunError: ReduxHelper.extractError(action),
      });
    case AT.GT_ESTIMATE_RERUN_CLEAR_DATA:
      return Object.assign({}, state, {
        rerunningData: false,
        rerunData: null,
        rerunError: null,
      });
    case AT.GT_ESTIMATE_RESET_PROCESSING: {
      return Object.assign({}, state, { resetingProcessing: true });
    }
    case AT.GT_ESTIMATE_RESET_PROCESSING_SUCCESS: {
      return Object.assign({}, state, {
        resetingProcessing: false,
        resetProcessing: action.payload,
        resetProcessingError: null,
      });
    }
    case AT.GT_ESTIMATE_RESET_PROCESSING_FAIL:
      return Object.assign({}, state, {
        resetingProcessing: false,
        resetProcessing: null,
        resetProcessingError: ReduxHelper.extractError(action),
      });
    case AT.GT_ESTIMATE_RESET_PROCESSING_CLEAR:
      return Object.assign({}, state, {
        resetingProcessing: false,
        resetProcessing: null,
        resetProcessingError: null,
      });
    case AT.GT_ESTIMATE_UPDATE_DATA: {
      return Object.assign({}, state, { updatingData: true });
    }
    case AT.GT_ESTIMATE_UPDATE_DATA_SUCCESS: {
      return Object.assign({}, state, {
        updatingData: false,
        updateData: action.payload,
        updateError: null,
      });
    }
    case AT.GT_ESTIMATE_UPDATE_DATA_FAIL:
      return Object.assign({}, state, {
        updatingData: false,
        updateData: null,
        updateError: ReduxHelper.extractError(action),
      });
    case AT.GT_ESTIMATE_UPDATE_CLEAR_DATA:
      return Object.assign({}, state, {
        updatingData: false,
        updateData: null,
        updateError: null,
      });
    case AT.GT_ESTIMATE_DELETE_DATA: {
      return Object.assign({}, state, { deletingData: true });
    }
    case AT.GT_ESTIMATE_DELETE_DATA_SUCCESS: {
      return Object.assign({}, state, {
        deletingData: false,
        deleteData: action.payload,
        deleteError: null,
      });
    }
    case AT.GT_ESTIMATE_DELETE_DATA_FAIL:
      return Object.assign({}, state, {
        deletingData: false,
        deleteData: null,
        deleteError: ReduxHelper.extractError(action),
      });
    case AT.GT_ESTIMATE_DELETE_CLEAR_DATA:
      return Object.assign({}, state, {
        deletingData: false,
        deleteData: null,
        deleteError: null,
      });
    case APP_ACTION_TYPES.LOGOUT:
      return defaultState;
    default:
      return state;
  }
};

export default gtEstimateReducer;
